import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-vehicle-settlement-component',
  templateUrl: './vehicle-settlement-component.component.html',
  styleUrls: ['./vehicle-settlement-component.component.scss'],
})
export class VehicleSettlementComponentComponent implements OnInit {
  @Input() dataSelected: any;
  highlightShow: boolean = true;
  features: boolean = false;
  claimprocess: boolean = false;
  cashless: boolean = false;
  portabilityShow: boolean = false;
  highlighSelected: boolean = true;
  featureSelected: boolean = false;
  claimprocessSelected = false;
  cashlessSelected = false;
  portabilitySelected = false;
  showIfclose: boolean = true;
  showIfopen: boolean = false;
  showMsg: boolean = false;
  show2Msg: boolean = false;
  show3Msg: boolean = false;
  show4Msg: boolean = false;
  ShowIfNotChange: boolean = true;
  cashlessOpen;
  cashlessHospital: any;
  hospitalList: any;
  items: any;
  filteredSearch: any;
  searchCity: string;
  searchTerm: string;
  searching: string;
  searchValue: string;
  careHospitalReq = {
    city: 'bangalore',
    hospitalname: null,
    pincode: null,
    district: null,
    state: null
  }

  careProducts: any = {
    care: false,
  }
  starProducts: any = {
    isStarProduct: false,
    familyHealthOptima: false,
    mediClassicIndividual: false,
    redCarpetIndividual: false,
    redCarpetFloater: false,
    comprehensiveIndividual: false,
    comprehensiveFloater: false,
    youngStarIndividual: false,
    youngStarFloater: false,
  }
  emiLabel: any = "";
  finalPremium: any;
  vehicleSellingPrice: any;
  multiPrice: number;
  concentrateValue: number;
  minIdv: number;
  maxIdv: number;
  idvValue: number;
  constructor(private modalCtrl: ModalController, private strg: StorageService) { }

  ngOnInit() {
  }
  ionViewDidEnter() {
    console.log(this.dataSelected)
    //console.log(JSON.parse(this.dataSelected.lombardQuoteResponse.responseParam))
    if (this.dataSelected.lombardQuoteResponse.responseParam) {
      let finalPre = JSON.parse(this.dataSelected.lombardQuoteResponse.responseParam)
      console.log(finalPre)
      //let passRes=JSON.parse(this.dataSelected.lombardQuoteResponse.responseParam);
      // this.finalPremium=this.dataSelected.lombardQuoteResponse.finalPremium;
      this.finalPremium = finalPre.finalPremium
      this.vehicleSellingPrice = finalPre.generalInformation.showRoomPrice
      this.idvValue = this.dataSelected.idvResponse.minidv
      console.log(this.idvValue)
    }
    else{
      this.finalPremium = this.dataSelected.lombardQuoteResponse.finalPremium
      this.vehicleSellingPrice = this.dataSelected.lombardQuoteResponse.generalInformation.showRoomPrice
      this.idvValue = this.dataSelected.idvResponse.minidv
    }


  }
  showHighlight() {
    this.highlightShow = true;
    this.features = false;
    this.claimprocess = false;
    this.cashless = false;
    this.portabilityShow = false;
    this.highlighSelected = true;
    this.featureSelected = false;
    this.claimprocessSelected = false;
    this.cashlessSelected = false;
    this.portabilitySelected = false;
  }
  showFeatures() {
    this.highlightShow = false;
    this.features = true;
    this.claimprocess = false;
    this.cashless = false;
    this.portabilityShow = false;
    this.highlighSelected = false;
    this.featureSelected = true;
    this.claimprocessSelected = false;
    this.cashlessSelected = false;
    this.portabilitySelected = false;
  }
  showClaim() {
    this.highlightShow = false;
    this.features = false;
    this.claimprocess = true;
    this.cashless = false;
    this.portabilityShow = false;
    this.highlighSelected = false;
    this.featureSelected = false;
    this.claimprocessSelected = true;
    this.cashlessSelected = false;
    this.portabilitySelected = false;

  }
  cashlessHosp() {
    this.highlightShow = false;
    this.features = false;
    this.claimprocess = false;
    this.cashless = true;
    this.portabilityShow = false;
    this.highlighSelected = false;
    this.featureSelected = false;
    this.claimprocessSelected = false;
    this.cashlessSelected = true;
    this.portabilitySelected = false;
  }
  portability() {
    this.highlightShow = false;
    this.features = false;
    this.claimprocess = false;
    this.cashless = false;
    this.portabilityShow = true;
    this.highlighSelected = false;
    this.featureSelected = false;
    this.claimprocessSelected = false;
    this.cashlessSelected = false;
    this.portabilitySelected = true;
  }
  closeModal() {
    this.modalCtrl.dismiss({});
  }
  clickOpen() {
    this.show3Msg = false;
    this.showMsg = !this.showMsg;
    this.show2Msg = false;
    this.show4Msg = false;
  }
  click2Open() {
    this.show3Msg = false
    this.show2Msg = !this.show2Msg;
    this.showMsg = false;
    this.show4Msg = false;
  }
  click3Open() {
    this.show3Msg = !this.show3Msg;
    this.show2Msg = false;
    this.showMsg = false;
    this.show4Msg = false;
  }
  click4Open() {
    this.show4Msg = !this.show4Msg;
    this.show3Msg = false;
    this.show2Msg = false
    this.showMsg = false
  }
}
